const type = 'CUSTOMER_ONBOARD_LOADING';

const startCustomerOnboard = () => ({
  type,
});

export { type };
export default startCustomerOnboard;
